module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.b0cf52e5.ttf";